import { useHasDuprPlus } from '@/hooks/useHasFeature'
import { CSSProperties, useEffect } from 'react'

declare global {
  interface Window {
    adsbygoogle?: { push?: (args: any) => void }[]
  }
}

interface GoogleAdProps {
  className?: string
  client?: string
  slot?: string
  format?: string
  layoutKey?: string
  style?: CSSProperties
}

const GoogleAd = ({ className, client, slot, format, layoutKey, style }: GoogleAdProps) => {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      try {
        ;(window.adsbygoogle = window.adsbygoogle || []).push({})
      } catch (e) {
        console.error('AdSense error:', e)
      }
    }
  }, [])

  const hasDuprPlus = useHasDuprPlus()

  return hasDuprPlus ? (
    <></>
  ) : (
    <ins
      className={`adsbygoogle ${className}`}
      style={{ display: 'block', ...style }}
      data-ad-client={client}
      data-ad-slot={slot}
      data-ad-format={format}
      data-ad-layout-key={layoutKey}
    />
  )
}

GoogleAd.defaultProps = {
  className: '',
  client: 'ca-pub-2494229136438878',
  slot: '3439665134',
  format: 'auto',
  layoutKey: '',
}

export default GoogleAd
